<template>
  <div class="app-topup-amount-selector">
    <slot name="txtBefore"></slot>
    <b-form>
      <b-form-group>
        <b-form-row>
          <b-col cols="12" md="">
            <label><slot name="lblAmount">Betrag in Euro</slot></label>
          </b-col>
          <b-col>
            <b-select
              name="amount"
              required
              v-model="amount"
              :options="availableAmounts"
            ></b-select>
          </b-col>
        </b-form-row>
      </b-form-group>
      <slot name="txtAfterSelector"></slot>
      <Stepper
        :show-prev="false"
        @next="next()"
        :disabled-next="loading"
        :loading-next="loading"
      >
        <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </Stepper>
    </b-form>

  </div>
</template>

<script>
import preFilledInput from '../../../../../mixins/preFilledInput'
import Stepper from '../../../../generic/Stepper.vue'
import slotProxy from '@/mixins/slotProxy'
import configBasedTopUpPrice from '@/mixins/configBasedTopUpPrice'

export const stepName = 'amountSelect'

export default {
  name: 'GenericAmountInput',
  components: { Stepper },
  mixins: [
    slotProxy(),
    preFilledInput('amount', 'defaultAmount'),
    configBasedTopUpPrice
  ],
  methods: {
    next () {
      this.$emit('amount-select', this.amount)
    }
  },
  computed: {
    availableAmounts: function () {
      return this.amounts.map(cents => {
        return {
          value: cents,
          text: this.price(cents)
        }
      })
    }
  },
  props: {
    amounts: {
      type: Array,
      required: true
    },
    defaultAmount: {
      type: Number,
      default: 1000
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
